
export default class AvailableCabin {
    cabin_number;
    price;
    available;
    expanded;

    constructor(dict) {
        this.cabin_number = dict['cabin'];
        this.price = dict['price'];
        this.available = dict['available'];
        this.expanded = false;
    }

    getNameKey() {
        switch (this.cabin_number) {
            case 1:
                return "text.large_cabin";
            case 2:
                return "text.small_cabin";
            default:
                return "text.family_cabin";
        }
    }

    getShortDescriptionKey() {
        switch (this.cabin_number) {
            case 1:
                return "text.large_cabin_short_description";
            case 2:
                return "text.small_cabin_short_description";
            default:
                return "text.family_cabin_short_description";
        }
    }

    getExpandedDescriptionKey() {
        switch (this.cabin_number) {
            case 1:
                return "text.l_apartment_text";
            case 2:
                return "text.s_apartment_text";
            default:
                return "text.f_apartment_text";
        }
    }

    getInfoRouterLink() {
        switch (this.cabin_number) {
            case 1:
                return "/large-cabin";
            case 2:
                return "/small-cabin";
            default:
                return "";
        }
    }    
}
